export default __webpack_public_path__ + "static/media/img-cynthiaavalos.d84ec13d.jpg";